module.exports = __webpack_public_path__ + "static/fonts/ProximaNova-Regular.410504d4.otf";